enum AppModule {
	Unknown = 'unknown',
	Present = 'present',
	Select = 'select',
	Share = 'share'
}

export default AppModule;
